import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                  SM
                </span>
                <span className="font-semibold text-base">SM专业指南</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                致力于提供专业、安全、负责任的SM知识科普，帮助每一位探索者建立正确的认知框架。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4 text-background-50">知识分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/sm-basics" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  基础概念
                </Link>
                <Link to="/category/sm-types" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  类型分类
                </Link>
                <Link to="/category/safety-guidelines" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  安全准则
                </Link>
                <Link to="/category/practice-guide" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  实践指南
                </Link>
                <Link to="/category/psychology-relationships" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  心理与关系
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4 text-background-50">热门文章</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/sm-core-terminology-guide" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  SM核心术语完全指南
                </Link>
                <Link to="/article/sm-history-origin-evolution" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  SM的起源与历史演变
                </Link>
                <Link to="/article/ssc-rack-safety-principles-comparison" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  SSC与RACK深度比较
                </Link>
                <Link to="/article/sm-beginner-checklist-action-plan" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  新手上路实用清单
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4 text-background-50">关于</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  关于我们
                </Link>
                <a href="#contact" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  联系我们
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} SM专业指南。本站内容仅供成人教育参考，不构成任何形式的医疗或法律建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors cursor-pointer" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}